export default function projects(
  state = { items: [], pending: [], current: null },
  action
) {
  switch (action.type) {
    case 'RECEIVE_PROJECTS':
      return { ...state, items: action.projects };
    case 'RECEIVE_PENDING':
      return { ...state, pending: action.projects };
    case 'RECEIVE_PROJECT':
      return { ...state, current: action.project };
    default:
      return state;
  }
}
